import {API_ROOT_URL} from 'envs/_current/config'

export const studentLink_resolveCode_Api = {
  backend: `Route::get('students/resolve-code/{code}', 'StudentLinkController@resolveCode');`,
  root: API_ROOT_URL,
  path: '/students/resolve-code/:code',
  method: 'GET',
}

export const studentLink_linkByCode_Api = {
  backend: `Route::post('students/link-by-code', 'StudentLinkController@linkByCode');`,
  root: API_ROOT_URL,
  path: '/students/link-by-code',
  method: 'POST',
}

export const studentLink_rotateSecretCode_Api = {
  backend: `Route::post('students/{id}/rotate-secret-code', 'StudentLinkController@rotateSecretCode');`,
  root: API_ROOT_URL,
  path: '/students/:id/rotate-secret-code',
  method: 'POST',
}

export const studentLink_getUserLinks_Api = {
  backend: `Route::get('students/{id}/user-links', 'StudentLinkController@getUserLinks');`,
  root: API_ROOT_URL,
  path: '/students/:id/user-links',
  method: 'GET',
}

export const studentLink_removeUserLink_Api = {
  backend: `Route::post('students/user-links/{id}/remove', 'StudentLinkController@removeUserLink');`,
  root: API_ROOT_URL,
  path: '/students/user-links/:id/remove',
  method: 'POST',
}

export const studentLink_getLinkRequests_Api = {
  backend: `Route::get('students/link-requests', 'StudentLinkController@getLinkRequests');`,
  root: API_ROOT_URL,
  path: '/students/link-requests',
  method: 'GET',
}

export const studentLink_approveLinkRequest_Api = {
  backend: `Route::post('students/link-requests/{id}/approve', 'StudentLinkController@approveLinkRequest');`,
  root: API_ROOT_URL,
  path: '/students/link-requests/:id/approve',
  method: 'POST',
}

export const studentLink_rejectLinkRequest_Api = {
  backend: `Route::post('students/link-requests/{id}/reject', 'StudentLinkController@rejectLinkRequest');`,
  root: API_ROOT_URL,
  path: '/students/link-requests/:id/reject',
  method: 'POST',
}

export const studentLink_createLinkRequest_Api = {
  backend: `Route::post('students/link-requests', 'StudentLinkController@createLinkRequest');`,
  root: API_ROOT_URL,
  path: '/students/link-requests',
  method: 'POST',
}
